// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsArray, IsEnum, IsInt, IsOptional, IsString, ValidateNested } from 'class-validator';
import { ExportFormat } from '../../../../types/requests/sync/export-sync-draft.request';
import { DomainApiModel } from '../../../../types/models/domain.model';
import { NodeApiModel } from '../../../../types/models/node.model';
import { ContractApiModel } from '../../../../types/models/contract.model';

class DomainForm implements Pick<DomainApiModel, keyof DomainForm> {
  @IsInt()
  id: number;

  @IsString()
  name: string;

  @IsString()
  shortName: string;
}

class NodeForm implements Pick<NodeApiModel, keyof NodeForm> {
  @IsInt()
  id: number;

  @IsString()
  name: string;
}

class ContractForm implements Pick<ContractApiModel, keyof ContractForm> {
  @IsInt()
  id: number;

  @IsInt()
  number: number;

  @IsOptional()
  @IsString()
  district: string | null;

  @IsOptional()
  @IsString()
  ea: string | null;

  @IsOptional()
  @IsString()
  descriptionOfWork: string | null;

  @IsOptional()
  @IsString()
  locationDescription: string | null;
}

export class ExportForm {
  @IsEnum(ExportFormat)
  format: ExportFormat;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  domains?: DomainForm[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  contracts?: ContractForm[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  topLevelNodes?: NodeForm[];
}
